import type { RouteRecordRaw } from 'vue-router'
import { ROUTES } from '@/router/routes.enum'
import { ACTION_ROLES } from '@/utils/constants'
import { requireAuthenticatedUser } from '@/router/guards'

export const reportRoutes: RouteRecordRaw[] = [
  {
    path: '/reports',
    name: ROUTES.REPORTS,
    component: () => import('@/modules/reports/views/ReportsIndex.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.REPORTS_VIEW }
  }
]
